const NodejsClientSocket = require("ws");

export class NodejsWSClient {
  constructor({
    address,
    headers,
    connectionTimeout,
    certification,
    withCredentials,
    onPing,
    onPong,
    onConnect,
    onDisconnect,
    onError,
    events,
  }) {
    this._socket = null;
    this.connection = null;
    this._isConnected = false;
    this.address = address;
    this.connectionTimeout = connectionTimeout;
    this.events = events;
    this.onPing = onPing;
    this.onPong = onPong;
    this.onConnect = onConnect;
    this.onDisconnect = onDisconnect;
    this.onError = onError;
    this.option = {
      extraHeaders: headers,
      withCredentials,
      certification,
    };
  }

  connect() {
    if (this._socket) {
      this._socket.disconnect();
      this._isConnected = false;
    }
    this._socket = new NodejsClientSocket(this.address, {
      handshakeTimeout: this.connectionTimeout || 30000, // ms
    });

    this._socket.on("open", () => {
      this._isConnected = true;
      this.connection = this._socket;
      if (this.onConnect) {
        this.onConnect(this);
      }
    });

    this._socket.on("ping", () => {
      if (this.onPing) {
        this.onPing();
      }
    });

    this._socket.on("pong", () => {
      if (this.onPong) {
        this.onPong();
      }
    });

    this._socket.on("message", (receivedMessage) => {
      const message =
        receivedMessage && receivedMessage.utf8Data
          ? receivedMessage.utf8Data
          : receivedMessage;
      let jsonMessage = "";
      try {
        jsonMessage = JSON.parse(message);
      } catch (e) {
        jsonMessage = message;
      }

      if (jsonMessage.type) {
        this.events.dispatch(jsonMessage.type, this, jsonMessage);
      }

      this.events.dispatch("*", this, jsonMessage);
    });

    this._socket.on("error", (...args) => {
      if (this.onError) {
        this.onError(...args);
      }
    });

    this._socket.on("close", (code, reason) => {
      this._isConnected = false;
      if (this.onDisconnect) {
        this.onDisconnect({ code, reason });
      }
    });

    return this;
  }

  isConnected() {
    return this._isConnected;
  }

  disconnect() {
    try {
      if (!this.connection) {
        return;
      }
      this.connection.close();
      return;
    } catch (e) {
      console.error(e);
      return;
    }
  }

  emitRaw(...args) {
    if (this.connection) {
      return this.connection.send(...args);
    }
  }

  pong() {
    if (!this.connection) {
      return;
    }
    this.connection.pong();
  }

  ping() {
    if (!this.connection) {
      return;
    }
    this.connection.ping();
  }

  emit(payloadOrEventType, miscPayload) {
    if (!this.connection) {
      return;
    }

    if (typeof payloadOrEventType === "string") {
      const eventType = payloadOrEventType;
      const payload = miscPayload;
      return this.connection.send(
        JSON.stringify({ ...payload, type: eventType })
      );
    } else if (typeof payloadOrEventType === "object") {
      const payload = payloadOrEventType;
      return this.connection.send(JSON.stringify({ ...payload }));
    }
  }

  addEventListener(...args) {
    return this.events.addEventListener(...args);
  }

  removeEventListener(...args) {
    return this.events.removeEventListener(...args);
  }

  removeEventListenerAll(...args) {
    return this.events.removeEventListenerAll(...args);
  }
}
